import React from "react";
import styled, { keyframes } from "styled-components";

// Keyframes for particle animation
const sparkle = keyframes`
  0% {
    transform: translate(0, 0) scale(0);
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
  100% {
    transform: translate(50px, 50px) scale(1);
    opacity: 0;
  }
`;

// Styled Components
const LoaderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--yellow);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 9999;
`;

const Particle = styled.div`
  position: absolute;
  width: 2px;
  height: 2px;
  background-color: ${({ color }) => color};
  border-radius: 50%;
  animation: ${sparkle} 2s infinite;
  animation-delay: ${({ delay }) => delay}s;
  left: ${({ x }) => x}%;
  top: ${({ y }) => y}%;
`;

const InternalContainer = styled.div`
  width: 100px;
  height: 100px;
  position: relative;
  .rotateSec {
    width: 100%;
    height: 100%;
    border-right: 2px solid var(--choco);
    border-top: 2px solid var(--choco);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: rotateLoader 1s infinite linear;
  }

  > img {
    width: 100%;
    height: 80%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

const Loader = () => {
  
  const particles = Array.from({ length: 50 }, (_, i) => ({
    color: `hsl(${Math.random() * 360}, 100%, 50%)`,
    delay: Math.random() * 2,
    x: Math.random() * 100,
    y: Math.random() * 100,
  }));

  return (
    <LoaderContainer>
      {particles.map((particle, index) => (
        <Particle
          key={index}
          color={particle.color}
          delay={particle.delay}
          x={particle.x}
          y={particle.y}
        />
      ))}
      <InternalContainer>
        <div className="rotateSec"></div>
        <img src="./logoBg.png" alt="logo" />
      </InternalContainer>
    </LoaderContainer>
  );
};

export default Loader;
